var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLngArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "down-arrow (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down-arrow-(1)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.80041537,9.83379329 L11.8513619,14.3348239 C11.9252539,14.4169257 12.0517119,14.4235811 12.1338137,14.3496891 C12.1390262,14.3449978 12.1439883,14.3400357 12.1486795,14.3348232 L16.1995881,9.8337926 C16.2734797,9.75169042 16.2668237,9.62523247 16.1847215,9.55134086 C16.1479966,9.5182886 16.1003371,9.5 16.0509289,9.5 L7.94907389,9.5 C7.83861694,9.5 7.74907389,9.58954305 7.74907389,9.7 C7.74907389,9.74940852 7.76736273,9.79706831 7.80041537,9.83379329 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLngArrow);
export default __webpack_public_path__ + "static/media/ic_lng_arrow.072f6852.svg";
export { ForwardRef as ReactComponent };